
import React from 'react';

const HouseUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<g fill='#2d2d2d' clipPath='url(#clip0_2045_2325)'>
				<path d='M25 26.002H7c-.55 0-1-.45-1-1v-13h2v12h16v-12h2v13c0 .55-.45 1-1 1z'></path>
				<path d='M27.36 15.773L16 6.303l-11.36 9.47-1.28-1.54 12-10c.37-.31.91-.31 1.28 0l12 10-1.28 1.54z'></path>
				<path d='M24 6.002h-2v5h2v-5zM25 30.002H7v2h18v-2zM28 24.002H4v2h24v-2zM19.75 24.002h-2v-5h-3.5v5h-2v-6c0-.55.45-1 1-1h5.5c.55 0 1 .45 1 1v6z'></path>
			</g>
			<defs>
				<clipPath id='clip0_2045_2325'>
					<path fill='#fff' d='M0 0H32V32H0z'></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default HouseUnderline;
